import { render, staticRenderFns } from "./MessageBulleted.vue?vue&type=template&id=58d4db47"
import script from "./MessageBulleted.vue?vue&type=script&lang=js"
export * from "./MessageBulleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports